



























import { Component, Prop, Vue } from "vue-property-decorator";
import { Question } from "@/store/modules/lib";
@Component({
  name: "LfsRadioBoxType",
})
export default class LfsSelectBox extends Vue {
  @Prop({
    type: String,
  })
  header!: string;
  @Prop({
    type: Array,
  })
  values!: string[];
  @Prop({
    type: Array,
  })
  items!: string[];
  @Prop({
    type: [Object, Boolean,String],
  })
  value!: Question;
  get item() {
    return this.value;
  }
  protected check:any = this.value
}
